export const isProd = () => {
  return (
    process.env.VUE_APP_KONSUL_API_URL ===
    'https://tkvhyw9cff.execute-api.us-east-1.amazonaws.com'
  )
}
